<template>
  <el-dialog
    title="更新算力规格"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :close-on-escape="false"
    width="80%"
    @closed="handleClose"
  >
    <el-form
      ref="editForm"
      :model="formData"
      :rules="formRules"
      label-width="120px"
      size="small"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="名称：" prop="title">
            <el-input v-model="formData.title" placeholder="请输入名称"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="资源类型：" prop="compute_type_id">
            <el-select 
              v-model="formData.compute_type_id" 
              placeholder="请选择资源类型" 
              style="width: 100%;"
              :loading="computeTypeLoading"
            >
              <el-option 
                v-for="item in computeTypeOptions" 
                :key="item.id" 
                :label="item.name" 
                :value="item.id"
              >
                <div class="compute-type-option">
                  <span class="compute-type-name">{{ item.name }}</span>
                </div>
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="提供商：" prop="provider_name">
            <el-select 
              v-model="formData.provider_name" 
              placeholder="请选择提供商" 
              style="width: 100%;"
              :disabled="true"
            >
              <el-option 
                :label="formData.provider_name" 
                :value="formData.provider_name"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="可用区：" prop="region">
            <el-select 
              v-model="formData.region" 
              placeholder="请选择可用区" 
              style="width: 100%;"
              :disabled="true"
            >
              <el-option 
                :label="formData.region" 
                :value="formData.region"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      
      <el-form-item label="提供商id：" prop="provider_id" style="display: none;">
        <el-input v-model="formData.provider_id" placeholder="提供商id"></el-input>
      </el-form-item>
      <el-form-item label="可用区id：" prop="region_id" style="display: none;">
        <el-input v-model="formData.region_id" placeholder="可用区id"></el-input>
      </el-form-item>
      <el-form-item label="是否纳管：" prop="ext_01" style="display: none;">
        <el-input v-model="formData.ext_01" placeholder="是否纳管"></el-input>
      </el-form-item>
      <el-form-item label="资源链接：" prop="ext_04" style="display: none;">
        <el-input v-model="formData.ext_04" placeholder="资源链接"></el-input>
      </el-form-item>
      
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="设备数量：" prop="device_quantity">
            <el-input v-model="formData.device_quantity" type="number" placeholder="请输入设备数量"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="CPU：" prop="cpu">
            <el-input v-model="formData.cpu" placeholder="请输入CPU"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="内存(GB)：" prop="memory_gb">
            <el-input v-model="formData.memory_gb" placeholder="请输入内存"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="GPU：" prop="gpu">
            <el-input v-model="formData.gpu" placeholder="请输入GPU"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="GPU数量：" prop="gpu_count">
            <el-input v-model="formData.gpu_count" type="number" placeholder="请输入GPU数量"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="GPU内存(GB)：" prop="gpu_memory_gb">
            <el-input v-model="formData.gpu_memory_gb" placeholder="请输入GPU内存"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="PCIe通讯：" prop="pcie_version">
            <el-input v-model="formData.pcie_version" placeholder="请输入PCIe版本"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="存储：" prop="storage">
            <el-input v-model="formData.storage" placeholder="请输入存储"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="计算网络：" prop="compute_network">
            <el-input v-model="formData.compute_network" placeholder="请输入计算网络"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="存储网络：" prop="storage_network">
            <el-input v-model="formData.storage_network" placeholder="请输入存储网络"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="业务网络：" prop="business_network">
            <el-input v-model="formData.business_network" placeholder="请输入业务网络"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="价格：" prop="price">
            <el-input v-model="formData.price" type="number" placeholder="请输入价格"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="价格单位：" prop="price_unit">
            <el-select v-model="formData.price_unit" placeholder="请选择价格单位">
              <el-option label="台·日" value="1"></el-option>
              <!-- <el-option label="卡·时" value="2"></el-option>
              <el-option label="T·月" value="3"></el-option>
              <el-option label="台·月" value="4"></el-option> -->
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="是否首页推荐：" prop="is_home_recommended">
            <el-select v-model="formData.is_home_recommended" placeholder="请选择">
              <el-option label="是" value="1"></el-option>
              <el-option label="否" value="0"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="是否发布：" prop="is_published">
            <el-select v-model="formData.is_published" placeholder="请选择">
              <el-option label="是" value="1"></el-option>
              <el-option label="否" value="0"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="排序：" prop="sort_order">
            <el-input v-model="formData.sort_order" type="number" placeholder="请输入排序"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="标签：" prop="tags">
            <el-input v-model="formData.tags" placeholder="请输入标签"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      
      <el-form-item label="产品介绍：" prop="product_intro">
        <el-input v-model="formData.product_intro" type="textarea" placeholder="请输入产品介绍"></el-input>
      </el-form-item>
      <el-form-item label="应用场景：" prop="application_scenarios">
        <el-input v-model="formData.application_scenarios" type="textarea" placeholder="请输入应用场景"></el-input>
      </el-form-item>
      <el-form-item label="产品规格：" prop="product_spec">
        <el-input v-model="formData.product_spec" type="textarea" placeholder="请输入产品规格"></el-input>
      </el-form-item>
      <el-form-item label="备注：" prop="remark">
        <el-input v-model="formData.remark" type="textarea" placeholder="请输入备注"></el-input>
      </el-form-item>
      <!-- <el-form-item label="创建时间：" prop="created_at">
        <el-date-picker
          v-model="formData.created_at"
          type="datetime"
          placeholder="选择创建时间"
          style="width: 100%"
        />
      </el-form-item>
      <el-form-item label="更新时间：" prop="updated_at">
        <el-date-picker
          v-model="formData.updated_at"
          type="datetime"
          placeholder="选择更新时间"
          style="width: 100%"
        />
      </el-form-item> -->
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="dialogVisible = false">取消</el-button>
      <el-button size="small" type="primary" @click="handleSubmit" :loading="submitLoading">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'EditComputeProduct',

  mounted() {
    this.fetchComputeTypes();
    this.fetchProviders();
  },

  data() {
    return {
      dialogVisible: false,
      computeProductId: '',
      submitLoading: false,
      computeTypeLoading: false,
      computeTypeOptions: [],
      providerLoading: false,
      providerOptions: [],
      regionLoading: false,
      regionOptions: [],
      formData: {
        title: '',
        compute_type_id: 0,
        cpu: '',
        memory_gb: '',
        gpu: '',
        gpu_count: 0,
        gpu_memory_gb: '',
        pcie_version: '',
        storage: '',
        compute_network: '',
        storage_network: '',
        business_network: '',
        price: 0,
        price_unit: '',
        is_home_recommended: '0',
        is_published: '0',
        sort_order: 0,
        tags: '',
        provider_name: '',
        provider_id: '',
        region: '',
        region_id: '',
        ext_01: 0,
        ext_04: 'https://baremetal.ltaidc.com/resources?specId={{id}}',
        device_quantity: 0,
        product_intro: '',
        application_scenarios: '',
        product_spec: '',
        remark: '',
        created_at: '',
        updated_at: ''
      },
      formRules: {
         title: [
          { required: true, message: '请输入名称', trigger: 'blur' }
        ],
        compute_type_id: [
          { required: true, message: '请选择资源类型', trigger: 'change' }
        ],
        gpu: [
          { required: true, message: '请输入GPU', trigger: 'blur' }
        ],
        gpu_count: [
          { required: true, message: '请输入GPU数量', trigger: 'blur' }
        ],
        price: [
          { required: true, message: '请输入价格', trigger: 'blur' }
        ],
        price_unit: [
          { required: true, message: '请输入价格单位', trigger: 'blur' }
        ],
        is_home_recommended: [
          { required: true, message: '请选择是否首页推荐', trigger: 'change' }
        ],
        is_published: [
          { required: true, message: '请选择上架状态', trigger: 'change' }
        ],
        sort_order: [
          { required: true, message: '请输入排序值', trigger: 'blur' }
        ],
        provider_name: [
          { required: true, message: '请选择提供商', trigger: 'blur' }
        ],
        provider_id: [
          { required: true, message: '请选择提供商', trigger: 'blur' }
        ],
        region: [
          { required: true, message: '请选择可用区', trigger: 'blur' }
        ],
        region_id: [
          { required: true, message: '请选择可用区', trigger: 'blur' }
        ],
        ext_01: [
          { required: true, message: '请选择是否纳管', trigger: 'change' }
        ],
        device_quantity: [
          { required: true, message: '请输入设备数量', trigger: 'blur' }
        ]
      }
    };
  },

  methods: {
    /**
     * 打开编辑弹窗
     */
    openDialog(row) {
      if (!row || !row.id) {
        this.$message.error('无效数据');
        return;
      }

      this.computeProductId = row.id;
      this.resetForm();

      // 填充数据
      Object.assign(this.formData, {
        title: row.title == null ? '' : row.title,
        compute_type_id: row.compute_type_id == null ? 0 : Number(row.compute_type_id),
        cpu: row.cpu == null ? '' : row.cpu,
        memory_gb: row.memory_gb == null ? '' : row.memory_gb,
        gpu: row.gpu == null ? '' : row.gpu,
        gpu_count: row.gpu_count == null ? 0 : row.gpu_count,
        gpu_memory_gb: row.gpu_memory_gb == null ? '' : row.gpu_memory_gb,
        pcie_version: row.pcie_version == null ? '' : row.pcie_version,
        storage: row.storage == null ? '' : row.storage,
        compute_network: row.compute_network == null ? '' : row.compute_network,
        storage_network: row.storage_network == null ? '' : row.storage_network,
        business_network: row.business_network == null ? '' : row.business_network,
        price: row.price == null ? 0 : row.price,
        price_unit: row.price_unit == null ? '' : String(row.price_unit),
        is_home_recommended: row.is_home_recommended == null ? '0' : String(row.is_home_recommended),
        is_published: row.is_published == null ? '0' : String(row.is_published),
        sort_order: row.sort_order == null ? 0 : row.sort_order,
        tags: row.tags == null ? '' : row.tags,
        provider_name: row.provider_name == null ? '' : row.provider_name,
        provider_id: row.provider_id == null ? '' : row.provider_id,
        region: row.region == null ? '' : row.region,
        region_id: row.region_id == null ? '' : row.region_id,
        ext_01: row.ext_01 == null ? 0 : row.ext_01,
        ext_04: 'https://baremetal.ltaidc.com/resources?specId={{id}}',
        device_quantity: row.device_quantity == null ? 0 : row.device_quantity,
        product_intro: row.product_intro == null ? '' : row.product_intro,
        application_scenarios: row.application_scenarios == null ? '' : row.application_scenarios,
        product_spec: row.product_spec == null ? '' : row.product_spec,
        remark: row.remark == null ? '' : row.remark,
        created_at: row.created_at ? new Date(row.created_at) : '',
        updated_at: row.updated_at ? new Date(row.updated_at) : ''
      });



      this.dialogVisible = true;

      this.$nextTick(() => {
        if (this.$refs.editForm) {
          this.$refs.editForm.clearValidate();
        }
      });
    },

    handleClose() {
      if (this.$refs.editForm) {
        this.$refs.editForm.resetFields();
      }
      this.computeProductId = '';
    },

    resetForm() {
      if (this.$refs.editForm) {
        this.$refs.editForm.resetFields();
      }
    },

    fetchComputeTypes() {
      this.computeTypeLoading = true;
      this.$axios.get('/api-30216/api/compute-types', {
        params: {
          page: 1,
          pageSize: 100 // Get enough options
        }
      })
        .then(res => {
          if (Array.isArray(res.data)) {
            this.computeTypeOptions = res.data.map(item => ({
              id: item.id,
              name: item.name
            }));
          } else {
            this.$message.error(res.message || '加载资源类型失败');
            this.computeTypeOptions = [];
          }
        })
        .catch(err => {
          this.$message.error('请求失败，请检查网络');
          console.error(err);
          this.computeTypeOptions = [];
        })
        .finally(() => {
          this.computeTypeLoading = false;
        });
    },

    fetchProviders() {
      this.providerLoading = true;
      this.$axios.get('/api-30216/api/regions')
          .then(res => {
            if (res.code === 200 && Array.isArray(res.data)) {
              this.providerOptions = res.data.map(item => ({
                provider: item.provider,
                provider_id: item.id
              }));
            } else {
              this.$message.error(res.message || '加载提供商失败');
              this.providerOptions = [];
            }
          })
        .catch(err => {
          this.$message.error('请求失败，请检查网络');
          console.error(err);
          this.providerOptions = [];
        })
        .finally(() => {
          this.providerLoading = false;
        });
    },





    /**
     * 提交表单（PUT 请求）
     */
    handleSubmit() {
      this.$refs.editForm.validate(valid => {
        if (!valid) return;

        const payload = { ...this.formData };
        
        // 设置关联类型为1（裸金属）
        payload.relation_type = 1;
        
        // 手动将数字字段转换为数字类型
        payload.compute_type_id = Number(payload.compute_type_id);
        payload.gpu_count = Number(payload.gpu_count);
        payload.price = Number(payload.price);
        payload.price_unit = Number(payload.price_unit);
        payload.is_home_recommended = Number(payload.is_home_recommended);
        payload.is_published = Number(payload.is_published);
        payload.sort_order = Number(payload.sort_order);
        payload.device_quantity = Number(payload.device_quantity);
        
        // 处理时间字段
        if (payload.created_at instanceof Date) {
          payload.created_at = payload.created_at.toISOString();
        }
        if (payload.updated_at instanceof Date) {
          payload.updated_at = payload.updated_at.toISOString();
        }
        
        this.submitLoading = true;

        this.$axios.put(`/api-30216/api/compute-products/${this.computeProductId}`, payload, {
          headers: { 'Content-Type': 'application/json' },
          transformRequest: [(data) => {
            return JSON.stringify(data);
          }]
        })
          .then(res => {
            const data = res.data || res;
            if (data.code === 200) {
              this.$message.success(data.message || '更新成功');
              this.dialogVisible = false;
              this.$emit('success'); // 通知父组件刷新
            } else {
              this.$message.error(data.message || '更新失败');
            }
          })
          .catch(err => {
            const msg = err.response && err.response.data && err.response.data.message || err.message || '请求失败';
            this.$message.error(msg);
            console.error('提交错误:', err);
          })
          .finally(() => {
            this.submitLoading = false;
          });
      });
    }
  }
};
</script>

<style scoped>
.dialog-footer {
  text-align: right;
}

.compute-type-option {
  display: flex;
  align-items: center;
  padding: 8px 0;
}

.compute-type-image {
  width: 40px;
  height: 40px;
  border-radius: 4px;
  margin-right: 12px;
  object-fit: cover;
}

.compute-type-name {
  font-size: 14px;
  font-weight: 500;
}
</style>